import { RESET_ALERTS } from "../actions/customReactPageActions";

const initialCustomReactPageState = {
	alerts: "none",
};

export const customReactPageReducer = (state = initialCustomReactPageState, action) => {
	switch (action.type) {
		case "CELL_INSERT_AT_END":
			// keeps state, notifys that fetching started
			return { ...state, alerts: "CELL_INSERT_AT_END" };
		case RESET_ALERTS:
			// keeps state, notifys that fetching started
			return initialCustomReactPageState;

		default:
			return state;
	}
};
